import { render, staticRenderFns } from "./ttshop_barters.vue?vue&type=template&id=89d81e5a&scoped=true&"
import script from "./ttshop_barters.vue?vue&type=script&lang=js&"
export * from "./ttshop_barters.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_barters.vue?vue&type=style&index=0&id=89d81e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d81e5a",
  null
  
)

export default component.exports